import React from 'react';
import { Bar, BarChart, ResponsiveContainer, XAxis, YAxis } from 'recharts';

const MiniBar = ({ data = [], color = '#1890ff' }) => {
  // Generate sample data if none provided
  const chartData = data.length > 0 ? data : [
    { name: '1', value: 10 },
    { name: '2', value: 15 },
    { name: '3', value: 8 },
    { name: '4', value: 20 },
    { name: '5', value: 12 },
    { name: '6', value: 18 },
    { name: '7', value: 25 }
  ];

  return (
    <ResponsiveContainer width="100%" height={46}>
      <BarChart data={chartData}>
        <XAxis dataKey="name" hide />
        <YAxis hide />
        <Bar dataKey="value" fill={color} radius={[2, 2, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default MiniBar;
